module.exports = __webpack_public_path__ + "img/featured_play_list.110092f5.svg";